/**
 * Facts the panes need that come from outside the workspace: who the client
 * is (for the client-facing preview's greeting and the send sheet's default
 * recipient) and the firm's branding (for the preview's logo and colors).
 */
import { createContext, useContext, type FC, type ReactNode } from "react";

export type RequestsEnv = {
  clientName: string | null;
  clientEmail: string | null;
  lawFirmName: string | null;
  lawFirmLogoUrl: string | null;
  enableWhitelabelForeignNationalIntake: boolean;
};

const EMPTY: RequestsEnv = {
  clientName: null,
  clientEmail: null,
  lawFirmName: null,
  lawFirmLogoUrl: null,
  enableWhitelabelForeignNationalIntake: false
};

const RequestsEnvContext = createContext<RequestsEnv>(EMPTY);

export const RequestsEnvProvider: FC<{
  value: RequestsEnv;
  children: ReactNode;
}> = ({ value, children }) => (
  <RequestsEnvContext.Provider value={value}>
    {children}
  </RequestsEnvContext.Provider>
);

export const useRequestsEnv = (): RequestsEnv => useContext(RequestsEnvContext);
